import React, { ReactElement, ReactNode } from 'react';
import {
  Icon,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material';
import FlexBox, { FlexGrow } from './FlexBox';
import { StyledText, TextSize } from './Text';

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#615e85',
    color: 'white',
    fontSize: '16px',
    border: '1px solid #dadde9',
    maxWidth: 500,
  },
});
type StyledTooltipProps = {
  header?: string;
  description?: string;
  graphics?: any;
  children: ReactElement<any, any> & ReactNode;
};

function StyledTooltip({
  header,
  description,
  graphics,
  children,
}: StyledTooltipProps): JSX.Element {
  return (
    <React.Fragment>
      <CustomWidthTooltip
        arrow
        placement="top"
        title={
          <React.Fragment>
            <FlexBox>
              <FlexGrow>
                <StyledText fontWeight='bold' >{header}</StyledText>
              </FlexGrow>
            </FlexBox>
            {description && (
              <FlexBox>
                <FlexGrow><StyledText fontWeight='400' textSize={TextSize.small}>{description}</StyledText></FlexGrow>
              </FlexBox>
            )}
          </React.Fragment>
        }>
        {children}
      </CustomWidthTooltip>
    </React.Fragment>
  );
}
export default StyledTooltip;
